import { useEffect, useId } from 'react';

interface SeoScriptProps {
  data: Record<string, unknown>;
}

export default function SeoScript({ data }: SeoScriptProps) {
  const seoId = useId();

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    script.setAttribute('data-seo-id', seoId);
    document.head.appendChild(script);

    return () => {
      const existing = document.head.querySelector(`script[data-seo-id="${seoId}"]`);
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, [data, seoId]);

  return null;
}